/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
import { useState } from 'react';

const lowerCaseIfString = (s) => (typeof s === 'string' ? s.toLowerCase() : s);

export const filterAndSort =
	(fields = []) =>
	(entities = [], filterText, sort) => {
		const lowerCasedFilterText = lowerCaseIfString(filterText);
		const shownEntities =
			filterText && fields.length > 0
				? entities.filter((entity) =>
						Object.entries(entity)
							.filter(([key]) => fields.includes(key))
							.map(([, value]) => value)
							.join('\n')
							.toLowerCase()
							.match(lowerCasedFilterText)
				  )
				: entities;
		const directionMultiplier = sort.direction === 'asc' ? 1 : -1;
		const sortedEntities = shownEntities.sort(
			(a, b) =>
				(lowerCaseIfString(a[sort.field] || '') > lowerCaseIfString(b[sort.field] || '') ? 1 : -1) *
				directionMultiplier
		);
		return sortedEntities;
	};

export const makeUseFilterAndSort =
	(fields, defaultField, defaultDirection = 'asc') =>
	(entities, filterText) => {
		const [sort, setSort] = useState({ field: defaultField, direction: defaultDirection });
		const values = filterAndSort(fields)(entities, filterText, sort);
		const setSortField = (field) => {
			const direction = sort.field !== field || sort.direction === 'desc' ? 'asc' : 'desc';
			setSort({ field, direction });
		};
		return { sort, setSortField, values };
	};

export const hasFieldError = (errors) =>
	Object.entries(errors).filter(([key, value]) => key !== 'form' && !!value).length > 0;
